import '@strapi/icons';
export { i as default } from './chunks/index-B393u3lO.mjs';
import 'react';
//# sourceMappingURL=index.mjs.map
